import {removeLoaderAnimation} from "../common/util";

$(() => {

    const $contentAnimate = $(".content-header-animate-scroll");
    for (let i = 0; i < 4; i++) {
        $($contentAnimate).children().clone().appendTo($contentAnimate);
    }

    setTimeout(function () {
        $(".container-text-hero h1").css({'left': '0', 'opacity': '1'});
        $(".container-text-hero h5").css({'bottom': '0', 'opacity': '1'});
        $(".container-text-hero a").css("opacity", "1");


        $(function () {
            const imgHeroList = $('.container-images-hero');
            const imgHeroItem = imgHeroList.find('.img-hero');
            let number = imgHeroItem.length;
            let random = Math.floor((Math.random() * number));
            imgHeroItem.eq(random).addClass('img-hero-active').siblings().removeClass('img-hero-active');

            setInterval(function () {
                let $imgActive = $(".img-hero-active")
                $('.hero-img-old-active').removeClass('hero-img-old-active');
                if ($imgActive.next().length != 0) {
                    $imgActive.addClass('hero-img-old-active').removeClass('img-hero-active').next().addClass('img-hero-active');
                } else {
                    $imgActive.addClass('hero-img-old-active').removeClass('img-hero-active');
                    $('.img-hero:first-of-type').addClass('img-hero-active')
                }
            }, 4000);

        });
    }, 800);

    removeLoaderAnimation($('.page-container'));
});
